<template>
  <PageShell :active="active">
    <section class="account-layout">
      <aside class="account-sidebar">
        <button v-for="item in menu" :key="item.name" :class="{ active: item.name === activeMenu }" type="button"
          @click="$router.push({ name: item.name })">
          {{ item.label }}
        </button>
      </aside>
      <main class="account-content">
        <slot />
      </main>
    </section>
  </PageShell>
</template>

<script>
import PageShell from './PageShell.vue'

export default {
  name: 'AccountLayout',
  components: {
    PageShell
  },
  props: {
    activeMenu: {
      type: String,
      required: true
    },
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menu: [
        { label: 'My Inquiries', name: 'inquiries' },
        { label: 'Orders', name: 'orders' },
        { label: 'Addresses', name: 'addresses' },
        { label: 'Account Settings', name: 'account-settings' },
        { label: 'Shipping Cost Calculator', name: 'shipping' },
        { label: 'Help', name: 'help' }
      ]
    }
  }
}
</script>

<style scoped>
.account-layout {
  max-width: 1100px;
  min-height: 720px;
  margin: 0 auto;
  padding: 40px 20px 70px;
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 56px;
}

.account-sidebar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
}

.account-sidebar button {
  border: 0;
  background: transparent;
  color: #333;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.2;
}

.account-sidebar button.active,
.account-sidebar button:hover {
  color: #F34B01;
}

.account-content {
  min-width: 0;
}

@media (max-width: 780px) {
  .account-layout {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .account-sidebar {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
